import { useState, useEffect, useCallback } from 'react';

interface IBudgetQuantityInputProps {
  value: string | number;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  isRemoved?: boolean;
  isChanged?: boolean;
}

const BudgetQuantityInput = (props: IBudgetQuantityInputProps) => {
  const [displayValue, setDisplayValue] = useState<string>('');

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      const valueStr = String(props.value);
      if (valueStr === '00' || valueStr === '0') {
        setDisplayValue('00');
      } else if (valueStr !== '') {
        setDisplayValue(valueStr);
      } else {
        setDisplayValue('');
      }
    } else {
      setDisplayValue('');
    }
  }, [props.value]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      
      // Se o usuário apagar tudo, mantém o valor anterior ao invés de deixar nulo
      if (!inputValue || inputValue.trim() === '') {
        const currentValue = props.value ? String(props.value) : '01';
        setDisplayValue(currentValue);
        return;
      }

      let cleanValue = inputValue.replace(/[^\d.,]/g, '');
      
      if (cleanValue.includes(',')) {
        cleanValue = cleanValue.replace(',', '.');
      }
      
      const parts = cleanValue.split('.');
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      if (parts.length === 2 && parts[1].length > 2) {
        cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
      
      if (!cleanValue) {
        const currentValue = props.value ? String(props.value) : '01';
        setDisplayValue(currentValue);
        return;
      }

      const numValue = Number.parseFloat(cleanValue);
      if (!Number.isNaN(numValue) && numValue === 0) {
        const currentValue = props.value ? String(props.value) : '01';
        setDisplayValue(currentValue);
        return;
      }

      setDisplayValue(cleanValue);
      props.onChange(cleanValue);
    },
    [props]
  );

  const handleBlur = useCallback(() => {
    if (!displayValue) {
      const currentValue = props.value ? String(props.value) : '01';
      setDisplayValue(currentValue);
      props.onChange(currentValue);
    } else {
      const numValue = Number.parseFloat(displayValue);
      // Validação: impede zero ou null
      if (Number.isNaN(numValue) || numValue <= 0) {
        const currentValue = props.value ? String(props.value) : '01';
        setDisplayValue(currentValue);
        props.onChange(currentValue);
      } else {
        const formattedValue = numValue % 1 === 0 ? String(numValue) : numValue.toFixed(2);
        setDisplayValue(formattedValue);
        props.onChange(formattedValue);
      }
    }
  }, [displayValue, props]);

  const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  }, []);

  const getBackgroundColor = () => {
    if (props.isRemoved) return '#fef2f2';
    if (props.isChanged) return '#d1fae5'; // Verde claro
    return undefined;
  };

  return (
    <input
      type="text"
      className={`form-control text-right ${props.className || ''} ${props.isRemoved ? '!bg-red-50' : ''}`}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={props.placeholder || '01'}
      disabled={props.disabled}
      style={{ backgroundColor: getBackgroundColor() }}
    />
  );
};

export default BudgetQuantityInput;

